import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  useToast,
  VStack
} from '@chakra-ui/react';
import i18next from 'i18next';
import Cookies from 'js-cookie';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiTransferAlt } from 'react-icons/bi';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

import { actionSignIn } from '../../api/postApi';
import { COMMON_WEB_PATH } from '../../constant';
import useInviteCode from '../../hook/useInviteCode';
import useTransCode from '../../hook/useTransCode';
import CustomCheckbox from './components/CustomCheckbox';
import LineLogin from './components/LineLogin';
import useGames from '../Game/useGames';

const iconStyle = 'text-gray-300';

const SigninForm = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`header.${key}`, { ...props });
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_common_form = (key) => t(`settings.form.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const toast = useToast();

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    user_name: Cookies.get(`${process.env.REACT_APP_WEB_NAME}_account`) || '',
    password: Cookies.get(`${process.env.REACT_APP_WEB_NAME}_password`) || '',
    remember_account:
      Cookies.get(`${process.env.REACT_APP_WEB_NAME}_account`) || false
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const trans_code = useTransCode();
  const invite_code = useInviteCode();

  const open_registration = window?.open_registration == 1;

  const { user_name, password, remember_account } = formData;

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleChecked = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked
    });
  };

  const handleSeePassword = () => {
    setShowPassword(!showPassword);
  };

  const { previousPage } = useGames({ customPreviousPage: '/' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonLoading(true);

    if (remember_account) {
      Cookies.set(`${process.env.REACT_APP_WEB_NAME}_account`, user_name, {
        expires: 365
      });
      Cookies.set(`${process.env.REACT_APP_WEB_NAME}_password`, password, {
        expires: 365
      });
    } else {
      Cookies.remove(`${process.env.REACT_APP_WEB_NAME}_account`);
      Cookies.remove(`${process.env.REACT_APP_WEB_NAME}_password`);
    }

    await actionSignIn({
      account: user_name,
      passwd: password,
      trans_code: trans_code
    })
      .then((data) => {
        if (Cookies.get('token')) {
          Cookies.remove('token');
        }
        Cookies.set('token', data.token, { expires: 365 });
        Cookies.remove('trans_code');
        dispatch({
          type: 'INITIALIZE_API',
          navigate: navigate
        });

        navigate(previousPage);
      })
      .finally(() => {
        setButtonLoading(false);
      });
  };

  return (
    <form className="max-w-[350px]" onSubmit={handleSubmit}>
      <VStack spacing={`15px`}>
        <FormControl
          display={'flex'}
          alignItems={'center'}
          pl="15px"
          gap="5px"
          isRequired
          bg="rgba(0, 0, 0, 0.4)"
          borderRadius="15px"
          border="1px solid"
          borderColor="cyan.400"
          boxShadow="0 0 8px cyan, 0 0 16px cyan, inset 0 0 6px rgba(0, 255, 255, 0.5)"
          _placeholder={{ color: 'cyan.300' }}
        >
          <Box>
            <Image
              minW="17px"
              minH="23px"
              maxW="17px"
              maxH="23px"
              src={`${COMMON_WEB_PATH}/blue-layout/signIn/account_icon.png`}
            />
          </Box>
          <InputGroup w="100%" bgSize="100% 100%">
            <Input
              type="text"
              name="user_name"
              bg="transparent"
              value={user_name}
              onChange={handleInputChange}
              placeholder={`${i18n_common('pleaseInput')} ${i18n_common_form(
                'account'
              )}`}
              border="none"
              px="5px"
              _focus={{
                border: 'none',
                outline: 'none !important',
                boxShadow: 'none !important'
              }}
            />
          </InputGroup>
        </FormControl>
        <FormControl
          display={'flex'}
          alignItems={'center'}
          pl="15px"
          gap="5px"
          isRequired
          bg="rgba(0, 0, 0, 0.4)"
          borderRadius="15px"
          border="1px solid"
          borderColor="cyan.400"
          boxShadow="0 0 8px cyan, 0 0 16px cyan, inset 0 0 6px rgba(0, 255, 255, 0.5)"
          _placeholder={{ color: 'cyan.300' }}
        >
          <Box>
            <Image
              minW="17px"
              minH="23px"
              maxW="17px"
              maxH="23px"
              src={`${COMMON_WEB_PATH}/blue-layout/signIn/pwd_icon.png`}
            />
          </Box>
          <InputGroup w="100%" bgSize="100% 100%">
            <Input
              type={showPassword ? 'text' : 'password'}
              bg="transparent"
              name="password"
              value={password}
              onChange={handleInputChange}
              placeholder={`${i18n_common('pleaseInput')} ${i18n_common_form(
                'password'
              )}`}
              border="none"
              px="5px"
              _focus={{
                border: 'none',
                outline: 'none !important',
                boxShadow: 'none !important'
              }}
            />

            <InputRightElement top="unset" bottom="0px">
              {showPassword ? (
                <FaEyeSlash
                  className="cursor-pointer"
                  onClick={handleSeePassword}
                />
              ) : (
                <FaEye className="cursor-pointer" onClick={handleSeePassword} />
              )}
            </InputRightElement>
          </InputGroup>
        </FormControl>
        {trans_code && (
          <FormControl isRequired>
            <FormLabel>{i18n_common_form('轉移代碼')}</FormLabel>
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <BiTransferAlt className={iconStyle} />
              </InputLeftElement>
              <Input
                type={'text'}
                variant={`brandPrimary`}
                name="trans_code"
                value={trans_code}
                isDisabled={true}
              />
            </InputGroup>
          </FormControl>
        )}
        <Flex>
          <CustomCheckbox
            isChecked={remember_account}
            name="remember_account"
            onChange={handleChecked}
            style={{
              placeSelf: 'flex-start'
            }}
            labelText={i18n_common('記住帳密')}
          />
        </Flex>
        <Flex
          justifyContent={'center'}
          alignItems={'center'}
          gap="5px"
          w="100%"
          position="absolute"
          bottom="-6em"
        >
          <Button
            sx={{
              bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/login_button.png)`,
              bgSize: 'contain',
              bgRepeat: 'no-repeat',
              bgPosition: 'center',
              background: 'transparent',
              _hover: {
                bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/login_button.png)`
              },
              _active: {
                bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/login_button.png)`
              },
              h: '80px'
            }}
            isLoading={buttonLoading}
            disabled={buttonLoading}
            py="20px"
            type="submit"
            w="180px"
          ></Button>
          {open_registration && (
            <Box
              sx={{
                bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/register_button.png) !important`,
                bgSize: 'contain !important',
                bgRepeat: 'no-repeat !important',
                bgPosition: 'center !important',
                background: 'transparent',
                _hover: {
                  bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/register_button.png)`
                },
                _active: {
                  bgImage: `url(${COMMON_WEB_PATH}/blue-layout/modal${i18next.language === 'tw' ? '' : `/${i18next.language}`}/register_button.png)`
                },
                h: '80px'
              }}
              isLoading={buttonLoading}
              disabled={buttonLoading}
              py="20px"
              as={Link}
              to="../signup"
              w="180px"
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
            ></Box>
          )}
          {/* <GoogleLoginButton
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          /> */}
          {/* <CreditPage>
            <GoogleLoginV2 />
            <TelegramLogin
              setButtonLoading={setButtonLoading}
              buttonLoading={buttonLoading}
            />
          </CreditPage> */}
        </Flex>
        {process.env.REACT_APP_LINE_CUSTOMER && (
          <LineLogin
            setButtonLoading={setButtonLoading}
            buttonLoading={buttonLoading}
          />
        )}
      </VStack>
    </form>
  );
};

export default SigninForm;
